
(() => {
  const DURATION = 400;

  const swing = (p) => 0.5 - Math.cos(p * Math.PI) / 2;

  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slide(el, open, done) {
    if (el._slideRaf) cancelAnimationFrame(el._slideRaf);

    if (reduced()) {
      el.style.display = open ? 'block' : 'none';
      el.style.height = '';
      done?.();
      return;
    }

    const from = el.offsetHeight;
    if (open) el.style.display = 'block';

    const prevH = el.style.height;
    el.style.height = 'auto';
    const to = open ? el.offsetHeight : 0;
    el.style.height = prevH || from + 'px';

    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min(1, (t - t0) / DURATION);
      el.style.height = from + (to - from) * swing(p) + 'px';
      if (p < 1) {
        el._slideRaf = requestAnimationFrame(step);
      } else {
        el._slideRaf = null;
        el.style.height = '';
        if (!open) el.style.display = 'none';
        done?.();
      }
    };
    el.style.height = from + 'px';
    el._slideRaf = requestAnimationFrame(step);
  }

  function contentOf(wrap) {

    return [...wrap.children].find((c) => c.classList.contains('jsSlideToggleContent'));
  }

  function setState(wrap, open) {
    wrap.classList.toggle('active', open);
    wrap.querySelector('.buttonSlideToggle')?.setAttribute('aria-expanded', String(open));
  }

  document.addEventListener('click', (e) => {
    const head = e.target.closest('.jsSlideToggle');
    if (!head) return;
    const wrap = head.closest('.jsSlideToggleWrap');
    if (!wrap) return;
    e.preventDefault();

    const willOpen = !wrap.classList.contains('active');

    for (const sib of wrap.parentElement.children) {
      if (sib === wrap || !sib.classList.contains('jsSlideToggleWrap')) continue;
      if (!sib.classList.contains('active')) continue;
      setState(sib, false);
      const c = contentOf(sib);
      if (c) slide(c, false);
    }

    setState(wrap, willOpen);
    const content = contentOf(wrap);
    if (content) slide(content, willOpen);
  });

})();
